const projects = [
	{
		id: "partify",
		src: "images/Partify_Screenshot.jpg",
		text: "Partify, Inc.",
		link: "https://www.partifyusa.com/",
		title: "Partify, Inc.",
		bio: `At Partify, I work as a Web Developer building and maintaining customer-facing eCommerce features on their Shopify storefront.

Day-to-day I design and implement UI components using HTML, CSS, JavaScript, and Shopify Liquid — with a focus on responsive, cross-browser experiences that work seamlessly across desktop and mobile.

I use Shopify CLI to manage theme development workflows, and collaborate closely with the team to ship production-ready features that improve performance, page load speed, and conversion rates.`,
	},
	{
		id: "cashew",
		src: "images/CashewGetsaJob.jpg",
		text: "Cashew Gets a Job",
		link: "https://cashewgetsajob.com/",
		title: "Cashew Gets a Job",
		bio: `Cashew Gets a Job is a custom Shopify storefront and React/Next.js web experience built for a children's book client.

The site integrates the Shopify Admin API to dynamically serve blog content and generate customer-specific discount codes based on user segmentation. A fully functional Shopify-powered storefront handles book and merchandise sales.

Built end-to-end using JavaScript, React, Next.js, Tailwind CSS, and Netlify CMS — giving the client a fast storefront and an easy content management workflow with no technical knowledge required.`,
	},
	{
		id: "blogconnect",
		src: "images/BlogConnect.jpg",
		text: "BlogConnect: Comment Manager",
		link: "https://apps.shopify.com/blogconnect",
		title: "BlogConnect: Comment Manager",
		bio: `BlogConnect is a published Shopify App Store app that replaces Shopify's basic native blog comments with a full threaded discussion system and comment moderation panel — all directly inside the Shopify admin.

Built and shipped as a self-employed project, the app navigates Shopify's full partner ecosystem: the App Store review process, the partner dashboard, and billing and subscription APIs.

Developed using React, Node.js, and the Shopify App Bridge, with a focus on seamless merchant UX and adherence to Shopify's UI guidelines.`,
	},
];

export default projects;
